module.exports = __webpack_public_path__ + "static/media/20181123_050640.e19df633.jpg";